<template>
  <div class="row">
    <div class="col-xl-6 col-lg-12" @subscriptionsChanged="reloadData()">
      <h1 v-if="hasSubscriptions">Hvilke varsler vil du legge til?</h1>
      <h1 v-else>Mine varsler</h1>
      <Spinner v-if="isLoading" />

      <p v-if="userSubscriptionsFailed && !isLoading">
        OOPS! Vi har problemer med å laste inn data. Abonnementene dine er derfor ikke tilgjengelige akkurat nå. 
        <br><br>Prøv igjen om litt. 
        <br><br>Hvis feilen vedvarer setter vi stor pris på tilbakemelding!
      </p>
      <p v-else-if="!isLoading">
        Velg hvilke typer naturfare du ønsker å motta varsel om. Du kan enkelt
        endre valgene senere hvis du ønsker det.
      </p>
      <div v-if="!userSubscriptionsFailed && !isLoading">
        <ul id="subscription-types">
          <li
            v-for="subscriptionType in subscriptionTypes"
            :key="subscriptionType.hazardTypeId"
          >
            <div class="li-heading">
              <label v-if="userSubscribeToHazardType(subscriptionType)">
                <input
                  type="checkbox"
                  :checked="anyActive(subscriptionType.hazardTypeId)"
                  @change="togglePauseSubType(subscriptionType.hazardTypeId)"
                />
                <strong>{{ subscriptionType.displayName }}</strong>
              </label>
              <label v-else>
                <input
                  type="checkbox"
                  v-b-modal="'modal-' + subscriptionType.hazardTypeId"
                  onclick="event.preventDefault()"
                  class
                />
                {{ subscriptionType.displayName }}
              </label>
              <InfoPopup
                class
                :popid="getPopId(subscriptionType.hazardTypeId)"
                :text="getInfoText(subscriptionType.hazardTypeId)"
              />
              <transition name="fade">
                <ul id="user-subscriptions">
                  <transition-group name="fade" mode="out-in">
                    <li
                      v-for="subscription in userSubscrptionsOfType(
                        subscriptionType
                      )"
                      :key="subscription.id"
                      class="sub"
                    >
                      <SubscriptionCard
                        :subscription="subscription"
                        :subscriptionType="subscriptionType"
                        @subscriptionsChanged="reloadData()"
                      />
                    </li>
                  </transition-group>
                </ul>
              </transition>
              <transition name="fade">
                <button
                  type="button"
                  v-if="userSubscribeToHazardType(subscriptionType)"
                  onclick="event.preventDefault()"
                  v-b-modal="'modal-' + subscriptionType.hazardTypeId"
                  class="btn btn-nve btn-add-more"
                >
                  <span class="add-more-plus">+</span>
                  <span>
                    Nytt varsel om
                    {{ subscriptionType.displayName.toLowerCase() }}
                  </span>
                </button>
              </transition>
            </div>
            <NewOrEditSubscription
              :subscriptionType="subscriptionType"
              @subscriptionSaved="reloadData()"
            />
          </li>
        </ul>
        <br />
        <div>
          <button
            v-if="hasActiveSubscriptions"
            type="button"
            @click="pauseAll()"
            class="btn btn-nve btn-add-more btn-action"
          >
            <img
              src="../assets/icons/pause-alle.svg"
              alt="Pause alle varsler"
            />
            Pause alle varsler
            <a
              class="todate container"
              v-b-modal="'modalPause'"
              v-on:click.stop.prevent
            >
              <span v-if="pauseDate"
                >Pauset til {{ pauseDate | dateFormat("D.M.YYYY") }}</span
              >
              <span v-else>Til dato</span>
            </a>
          </button>
          <button
            v-if="hasOnlyInactiveSubs"
            type="button"
            @click="resumeAll()"
            class="btn btn-nve btn-add-more btn-action"
          >
            <img
              src="../assets/icons/play-alle.svg"
              alt="Gjenoppta alle varsler"
            />
            Gjenoppta alle varsler
            <a
              class="todate container"
              v-b-modal="'modalPause'"
              v-on:click.stop.prevent
            >
              <span v-if="pauseDate"
                >Pauset til {{ pauseDate | dateFormat("D.M.YYYY") }}</span
              >
              <span v-else>Til dato</span>
            </a>
          </button>
        </div>
      </div>
    </div>
    <div class="col-xl-3"></div>
    <b-modal
      id="modalPause"
      :hide-footer="true"
      :hide-header="true"
      ref="modalPause"
    >
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="closeModal()"
      >
        <span aria-hidden="true">
          <img src="../assets/icons/close.svg" alt="Lukk pause-velger" />
        </span>
      </button>
      <div class="container">
        <h1 class="modal-title">
          Pause alle varslene til valgt dato
        </h1>
        <p>
          Her velger du den datoen du ønsker at alle varslene dine skal starte
          opp igjen.
        </p>
        <div class=" w-100 text-center">
          <b-calendar
            v-bind="labels['no']"
            v-model="tempDate"
            :start-weekday="weekday"
            :min="minDate"
            :hide-header="true"
          />
          <div class="buttons">
            <button
              type="button"
              class="btn btn-nve btn-primary ok"
              @click="closeModal(tempDate)"
            >
              Bruk valgt dato
            </button>
            <a href="#" class="cancel" @click="closeModal()">Avbryt</a>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import InfoPopup from "@/components/InfoPopup.vue";
import SubscriptionCard from "./SubscriptionCard.vue";
import NewOrEditSubscription from "./NewOrEditSubscription.vue";
import TypeService from "../store/TypeService.js";
import Spinner from "../components/Spinner"
import moment from "moment";

export default {
  name: "MySubscription",
  components: {
    SubscriptionCard,
    NewOrEditSubscription,
    InfoPopup,
    Spinner
  },
  data() {
    const tomorrow = moment(new Date()).add(1, "days");
    return {
      TypeService: TypeService,
      loadingData: true,
      tempDate: null,
      context: null,
      minDate: new Date(tomorrow.year(), tomorrow.month(), tomorrow.date()),
      locales: [{ value: "no", text: "Norsk (no)" }],
      weekday: 1,
      weekdays: [
        { value: 0, text: "Mandag" },
        { value: 1, text: "Tirsdag" },
        { value: 2, text: "Onsdag" },
        { value: 3, text: "Torsdag" },
        { value: 4, text: "Fredag" },
        { value: 5, text: "Lørdag" },
        { value: 6, text: "Søndag" },
      ],
      labels: {
        no: {
          labelPrevYear: "Neste mnd.",
          labelPrevMonth: "Forrige mnd.",
          labelCurrentMonth: "Denne mnd.",
          labelNextMonth: "Neste mnd.",
          labelNextYear: "Neste år",
          labelToday: "I dag",
          labelSelected: "Valgt dato",
          labelNoDateSelected: "Ingen dato valgt",
          labelCalendar: "Kalender",
          labelNav: "Kalendernavigasjon",
          labelHelp:
            "Du kan bla i kalenderen med piltastene. Velg år og mnd i toppen.",
        },
      },
    };
  },
  computed: {
    isLoading() {
      return this.$store.getters.isLoading;
    },
    hasSubscriptions() {
      return this.$store.hasSubscriptions;
    },
    hasActiveSubscriptions() {
      return this.$store.getters.hasActiveSubscriptions;
    },
    hasOnlyInactiveSubs() {
      return this.$store.getters.onlyInactiveSubscriptions;
    },
    userSubscriptionsFailed() {
      return this.$store.getters.userSubscriptionsFailed;
    },
    subscriptionTypes() {
      return this.$store.getters.subscriptionTypes;
    },
    pauseDate() {
      return this.$store.getters.pauseDate;
    },
  },
  created() {
    this.newUser = this.$store.hasSubscriptions;
  },
  mounted() {
    this.loadingData = false;
  },
  methods: {
    async closeModal(date) {
      if (date) {
        this.pauseAll(date);
      }
      this.$refs.modalPause.hide();
    },
    userSubscribeToHazardType(item) {
      const userSubscriptions = this.$store.getters.userSubscriptions;
      if (!item || !userSubscriptions) {
        return false;
      }
      if (
        userSubscriptions.filter((x) => x.hazardTypeId === item.hazardTypeId)
          .length > 0
      ) {
        return true;
      }
      return false;
    },
    anyActive(subType) {
      const userSubscriptions = this.$store.getters.userSubscriptions;
      if (!subType || !userSubscriptions) {
        return false;
      }
      const active = userSubscriptions.filter(
        (x) => x.hazardTypeId === subType && x.isEnabled === true
      );
      return active && active.length > 0;
    },
    togglePauseSubType(subType) {
      const checked = this.anyActive(subType);
      const userSubscriptions = this.$store.getters.userSubscriptions;
      if (!subType || !userSubscriptions) {
        return false;
      }

      userSubscriptions
        .filter((x) => x.hazardTypeId === subType)
        .map((sub) => {
          if (checked) {
            axios.post(`/api/api/Subscription/Pause/${sub.id}`).then(
              () => {
                this.reloadData();
              },
              (error) => {
                this.errors.push(error);
              }
            );
          } else {
            axios.post(`/api/api/Subscription/Resume/${sub.id}`).then(
              () => {
                this.reloadData();
              },
              (error) => {
                this.errors.push(error);
              }
            );
          }
        });
    },
    userSubscrptionsOfType(item) {
      const userSubscriptions = this.$store.getters.userSubscriptions;
      if (!item || !userSubscriptions) {
        return false;
      }
      return userSubscriptions.filter(
        (x) => x.hazardTypeId === item.hazardTypeId
      );
    },
    async reloadData() {
      this.loadingData = true;
      try {
        await this.$store.dispatch("getSubscriptions");
      } finally {
        this.loadingData = false;
      }
    },   
    pauseAll(date) {
      this.loadingData = true;
      const ref = this;
      axios.post("/api/api/Subscription/Pause/All", { Date: date }).then(
        () => {
          ref.reloadData();
        },
        (error) => {
          ref.errors.push(error);
        }
      );
    },
    resumeAll() {
      this.loadingData = true;

      axios.post("/api/api/Subscription/Resume/All").then(
        () => {
          this.reloadData();
        },
        (error) => {
          this.errors.push(error);
        }
      );
    },
    getPopId(hazardTypeId) {
      return "popover-id-" + hazardTypeId;
    },
    getInfoText(hazardTypeId) {
      return TypeService.getInfoText(hazardTypeId);
    },
  },
};
</script>

<style lang="scss" scoped>
.todate {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #044962 !important;
  mix-blend-mode: normal;
  opacity: 0.69;
  // position: relative;
  margin-left: 10px;
  margin-right: 0px;
  padding: 0;
}

.todate > span {
  white-space: nowrap;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
  li {
    margin: 16px 0 0 0;
  }
}

#user-subscriptions {
  max-width: 550px;
}

.pause-all {
  width: 4px;
  height: 10px;
  left: 16px;
  top: 11px;
}

svg.feather {
  color: #444;
}

.li-heading {
  line-height: 140%;
}

.btn-add-more {
  margin-bottom: 8px;
}

.btn-action {
  font-size: 16px;
  font-weight: 600;
  background-color: #e7f4ff;
  border: 1px solid #6996a3;
  box-sizing: border-box;
  &:active,
  &:hover {
    background: #d1eaff;
    border: 1px solid #6996a3;
  }

  &:active {
    margin-top: -1px;
    margin-left: -1px;
    margin-bottom: 7px;
    border: 2px solid #5e9ed6;
  }

  & > img {
    height: 11px;
    width: 10px;
    margin-right: 8px;
    margin-left: 6px;
    margin-bottom: 3px;
  }
}

strong {
  margin-left: 4px;
}

.cancel {
  margin-left: 48px;
}

.buttons {
  margin-top: 48px;
}
</style>
